/* eslint-disable */
<template>
  <div id="instructor-table-dynamic">
    <v-container v-if="adminAjaxing && activeViewAdmin != 'Treeview'" class="loader">
      <v-progress-circular indeterminate size=70 :width="5"></v-progress-circular>
    </v-container>
    <!--schools table-->
    <el-table
    v-if="activeViewAdmin === 'Schools' && !adminAjaxing"
    :data="schools.data"
    :header-cell-class-name="sortClasses"
    @sort-change="sortChange"
    @selection-change="selectionChange"
    style="width: 100%"
    :max-height="maxHeight"
    >
      <!--<el-table-column-->
      <!--  type="selection"-->
      <!--  width="55"-->
      <!--  >-->
      <!--</el-table-column>-->
      <el-table-column
        prop=""
        label=""
        align="center"
        width="80">
        <template slot-scope="scope">
          <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px" >
            <div class="school-wrapper" :style="schoolStyle({logo: scope.row.logo, color:scope.row.active_color})"></div>
          </v-responsive>
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="name"
        label="Organization"
        min-width= "200"
        >
      </el-table-column>
      <el-table-column
        width="400"
        prop=""
        label="Integrations">
        <template slot-scope="scope">
          <div v-if="updateIntegrations && scope.row.integrations.length > 0">
              <el-tag  v-for="(integration, index) in scope.row.integrations" v-if="(showAllIntegrations[scope.row.id]) ? index > -1 : index <= 2" :key="index" type="info">{{integration}}</el-tag>
              <el-tag  tabIndex="0" aria-label="Show more integrations" @click="showIntegrations(scope.row)" v-show="scope.row.integrations.length > 3 && !showAllIntegrations[scope.row.id]"  type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">...</el-tag>
              <el-tag  @click="showIntegrations(scope.row)" v-show="scope.row.integrations.length > 3 && showAllIntegrations[scope.row.id]" type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">
                <v-icon small>clear</v-icon>
              </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="100"
        prop="instructors"
        label="Instructors">
        <template slot-scope="scope">
          <v-btn icon flat color="primary" tabIndex="0" aria-label="All Instructors Table" @click="setNavData({activeView:'Instructors', queryParams:{school_id: scope.row.id}, breadcrumbs:[]})">
            <v-icon>person</v-icon>
          </v-btn>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="100"
        prop="bulbs"
        label="Bulbs">
        <template slot-scope="scope">
          <v-btn icon flat color="primary" tabIndex="0" aria-label="Media Library Table" @click="setNavData({activeView:'Bulbs', queryParams:{school_id: scope.row.id}, breadcrumbs:[]})">
            <v-icon>lightbulb</v-icon>
          </v-btn>
        </template>
      </el-table-column>
      <!--<el-table-column-->
      <!--  header-align="center"-->
      <!--  align="center"-->
      <!--  width="100"-->
      <!--  prop="courses"-->
      <!--  label="Classes">-->
      <!--  <template slot-scope="scope">-->
      <!--    <span>{{scope.row.courses}}</span>-->
      <!--  </template>-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
      <!--  header-align="center"-->
      <!--  align="center"-->
      <!--  width="100"-->
      <!--  prop="learners"-->
      <!--  label="Learners">-->
      <!--  <template slot-scope="scope">-->
      <!--    <span>{{scope.row.learners}}</span>-->
      <!--  </template>-->
      <!--</el-table-column>-->
      <template slot="empty">
        <div class="column">
          <span>
            No Schools
          </span>
        </div>
      </template>
    </el-table>

    <!--instructors table-->
    <el-table
    v-if="activeViewAdmin === 'Instructors'  && !adminAjaxing"
    :data="instructors.data"
    :header-cell-class-name="sortClasses"
    @sort-change="sortChange"
    @selection-change="selectionChange"
    style="width: 100%"
    :max-height="maxHeight"
    >
      <el-table-column
        type="selection"
        width="55"
        >
      </el-table-column>
      <el-table-column
        prop=""
        label=""
        align="center"
        width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.is_admin === 1">
            <el-badge :value="adminString" class="item">
              <v-avatar
                v-if="scope.row.picture"
                size="32"
                color="grey lighten-4"
              >
                <img :src="scope.row.picture" alt="avatar">
              </v-avatar>
              <v-icon v-if="!scope.row.picture" large color="grey">account_circle</v-icon>
            </el-badge>
          </template>
          <template v-else>
              <v-avatar
                v-if="scope.row.picture"
                size="32"
                color="grey lighten-4"
                >
                <img :src="scope.row.picture" alt="avatar">
              </v-avatar>
              <v-icon v-if="!scope.row.picture" large color="grey">account_circle</v-icon>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="teacher_name"
        label="Name"
        min-width= "250">
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="email"
        label="Email"
        min-width= "200">
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="school_name"
        label="Organization"
        width= "250"
        >
        <template slot-scope="scope" >
          <span class ="selectable" tabIndex="0" :aria-label="`Filter table by instructor's in ${scope.row.school_name}`"  @click="adminOrganizationSearch(scope.row.school_id, scope.row.school_name)">{{scope.row.school_name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        align="center"
        prop="bulbs_built"
        label="Bulbs Built"
        width= "150">
      </el-table-column>
      <el-table-column
        align="center"
        sortable="custom"
        prop="last_login"
        label="Last Login"
        width= "115">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="175"
        prop=""
        label="Instructor Login">
        <template slot-scope="scope">
          <v-btn flat icon @click="signInAsInstructor(scope.row.id)">
            <v-icon small class="branded-text" tabIndex="0" aria-label="Sign in as instructor">phonelink_lock</v-icon>
          </v-btn>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="column">
          <span>
            No Instructors
          </span>
        </div>
      </template>
    </el-table>

    <!--bulbs table-->
    <template v-if="(activeViewAdmin === 'Bulbs' && !adminAjaxing ) || activeViewAdmin === 'Treeview'">
      <el-row :gutter="12">
        <el-col :span="6" v-if="activeViewAdmin === 'Treeview'">
          <el-tree
            :props="folderTreeProps"
            :load="loadTreeFolderNode"
            :default-expanded-keys="expandedTreeFolderNode"
            node-key="id"
            lazy
            ref="tree"
            @node-drop="handleTreeFolderDrop"
            :allow-drag="allowTreeFolderDrag"
            :allow-drop="allowTreeFolderDrop"
            draggable
            :data="treeNode"
            @node-click="treeFolderNodeClicked"
            >
              <span slot-scope="{ node, data }" >
                <span class="el-tree_custom-node" :data-tree-id="data.id"  :data-parent-id="data.parentId"  v-droppable>
                  <v-icon class="branded-text pr-1 " v-if="data.parentId == null ">folder_special</v-icon>
                  <v-icon class="branded-text pr-1 " v-if="(!node.loading && data.parentId != null && data.schoolId != null)">domain</v-icon>
                  <v-icon class="branded-text pr-1 " v-if="(!node.loading && data.parentId != null && (data.schoolId == null ))">folder</v-icon>
                  <span  v-bind:class="[!node.loading ? 'folderName' : '']" v-bind:style= "[ node.isCurrent ? {fontWeight: 'bold'}:{} ]" > {{truncateFolderName(data.name, 20)}}</span>
                </span>
              </span>
          </el-tree> 
        </el-col>
        <el-col :span="activeViewAdmin === 'Treeview' ? 18 : 24">
          <v-container v-if="adminAjaxing && activeViewAdmin === 'Treeview'" class="loader">
            <v-progress-circular indeterminate size=70 :width="5"></v-progress-circular>
          </v-container>
          <el-table
            v-if=" (activeViewAdmin === 'Bulbs' ||  activeViewAdmin === 'Treeview') && !adminAjaxing"
            :data="isMediaLibraryPlaylists ? playlists.data : bulbs.data"
            :header-cell-class-name="sortClasses"
            @sort-change="sortChange"
            style="width: 100%"
            :max-height="maxHeight"
            @selection-change="handleRowSelection"
            >
            <el-table-column
              v-if="!isMediaLibraryPlaylists"
              type="selection"
              width="55"
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop=""
              label=""
              align="center"
              width="80"
              >
              <template slot-scope="scope">
                <ActionMenu
                  v-if="!isMediaLibraryPlaylists"
                  :menu="'admin'"
                  :bulb="scope.row" 
                  :data-bulb-id="scope.row.id"
                  :data-parent-node-id="scope.row.nodeId"
                  :thumbnail="scope.row.thumbnail"
                  :data-thumbnail="scope.row.thumbnail"
                  :disabled="selectedDataAdmin.length > 0"
                  :handlePopoverShow="handlePopoverShow"
                  aria-hidden="true"
                  >
                </ActionMenu>
                <ActionMenu
                  v-else
                  :menu="'admin'"
                  :playlist="scope.row"
                  :icon="'playlist_play'"
                  :handlePopoverShow="handlePopoverShow"
                  aria-hidden="true"
                  >
                </ActionMenu>
              </template>
            </el-table-column>
            
            <!-- Bulb Name-->
            <el-table-column
              sortable="custom"
              prop="name"
              :label="isMediaLibraryPlaylists ? 'Playlist' : 'Bulb'"
              min-width= "250">
              <template slot-scope="scope">
                <div class='row-start'>
                  <Tooltip
                    v-if="LTIlaunch && LTIdata.contentId === null && !isMediaLibraryPlaylists"
                    top >
                    <img  @click="handleDialogOpen({type:'lti' , data:scope.row})" class="lms-img selectable mr-2" :src="LMSdata.img">
                    <template v-slot:text>
                      Set Bulb Link
                    </template>
                  </Tooltip>
                  <Tooltip
                    v-if="LTIdata.contentId == scope.row.id && !isMediaLibraryPlaylists"
                    top>
                    <img  @click="setDashModal({ type: 'confirmUnlink' })" class="lms-img selectable mr-2" :src="LMSdata.img">
                    <template v-slot:text>
                      Unlink Bulb
                    </template>
                  </Tooltip>
                  <Tooltip v-if="passbackLinking" top>
                    <v-icon
                      @click="passbackContent({bulbId: scope.row.id, bulbName: scope.row.name, type: 'bulb'})"
                      class="lms-img selectable mr-2">
                      exit_to_app
                    </v-icon>
                    <template v-slot:text>
                      Passback Bulb
                    </template>
                  </Tooltip>
                  <Tooltip
                    top
                    :delay-time="0">
                    <span
                      class="branded-text cursor"
                      tabIndex="0"
                      aria-label="Preview bulb"
                      :class="[ isSafari ? 'safari-bulb-name-truncate admin-media-library' : 'bulb-name-truncate' ]"
                      @click="handleMediaNameClicked(scope.row)">
                      {{ scope.row.name }}
                    </span>
                    <template v-slot:text>
                      {{ scope.row.name }}
                    </template>
                  </Tooltip>
                </div>
              </template>
            </el-table-column>

            <!-- Bulb Tags-->
            <el-table-column
              v-if="!isMediaLibraryPlaylists"
              prop="tags"
              label="Tags"
              min-width= "250">
              <template slot-scope="scope" :data-bulb-id="scope.row.id" :data-thumbnail="scope.row.thumbnail">
                <div>
                  <div  class="bulbs-tag-container" v-if="updateTags && scope.row.tags.length > 0">
                    <el-tag   v-for="(tag, index) in scope.row.tags" @click="adminKeywordSearch(tag)" v-if="(showAllTags[scope.row.id]) ? index > -1 : index <= 2" :key="index" :style="tagStyle(tag)">{{tag.text}}</el-tag>
                    <div class="edit-tags" v-if="scope.row.tags.length <= 3">
                      <span  class="selectable"  @click="handleDialogOpen({type:'bulbInfo' , data:scope.row})" >Edit Tags</span>
                    </div>
                    <div class="edit-tags" v-if="scope.row.tags.length > 3 && showAllTags[scope.row.id]">
                      <span  class="selectable"  @click="handleDialogOpen({type:'bulbInfo' , data:scope.row})" >Edit Tags</span>
                    </div>
                    <el-tag  @click="showTags(scope.row)" v-show="scope.row.tags.length > 3 && !showAllTags[scope.row.id]"  tabIndex="0" aria-label="Show more tags" type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">...</el-tag>
                    <el-tag  @click="showTags(scope.row)" v-show="scope.row.tags.length > 3 && showAllTags[scope.row.id]" type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">
                      <v-icon small>clear</v-icon>
                    </el-tag>
                  </div>
                  <span v-if="scope.row.tags.length === 0 && scope.row.list_code != 0"  tabIndex="0" aria-label="Add tags" class="selectable" @click="handleDialogOpen({type:'bulbInfo' , data:scope.row})"  >Add Tags</span>
                </div>
              </template>
            </el-table-column>
            <!-- Playlist Tags-->
            <el-table-column
              v-else
              prop="playlistTags"
              label="Tags"
              min-width= "250">
              <template
                slot-scope="scope">
                <div>
                  <div
                    v-if="updateTags && scope.row.playlistTags.length > 0"
                    class="playlist-tag-container">
                    <el-tag
                      v-for="(playlistTag, index) in scope.row.playlistTags"
                      @click="adminKeywordSearch(playlistTag)"
                      v-if="(showAllTags[scope.row.id]) ? index > -1 : index <= 2"
                      :key="index" :style="tagStyle(playlistTag)">
                      {{ playlistTag.text ? playlistTag.text : playlistTag.tag.value }}
                    </el-tag>
                    <div
                      class="edit-tags"
                      v-if="scope.row.playlistTags.length <= 3">
                      <span
                        class="selectable"
                        @click="setDashModal({ type: 'playlistTags', playlist: scope.row })">
                        Edit Tags
                      </span>
                    </div>
                    <div
                      class="edit-tags"
                      v-if="scope.row.playlistTags.length > 3 && showAllTags[scope.row.id]">
                      <span
                        class="selectable"
                        @click="setDashModal({ type: 'playlistTags', playlist: scope.row })">
                        Edit Tags
                      </span>
                    </div>
                    <el-tag 
                      @click="showTags(scope.row)"
                      v-show="scope.row.playlistTags.length > 3 && !showAllTags[scope.row.id]"
                      tabIndex="0"
                      aria-label="Show more tags"
                      type="info"
                      style="margin:5px; background-color:#fff; border-color: #fff;"
                      class="cursor">
                      ...
                    </el-tag>
                    <el-tag
                      @click="showTags(scope.row)"
                      v-show="scope.row.playlistTags.length > 3 && showAllTags[scope.row.id]"
                      type="info"
                      style="margin:5px; background-color:#fff; border-color: #fff;"
                      class="cursor">
                      <v-icon
                        small>
                        clear
                      </v-icon>
                    </el-tag>
                  </div>
                  <span
                    v-if="scope.row.playlistTags.length === 0 && scope.row.list_code != 0"
                    tabIndex="0"
                    aria-label="Add tags"
                    class="selectable"
                    @click="setDashModal({ type: 'playlistTags', playlist: scope.row })">
                    Add Tags
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="school_name"
              label="Organization"
              width= "250">
              <template slot-scope="scope" :data-bulb-id="scope.row.id" :data-thumbnail="scope.row.thumbnail" >
                <span class ="selectable"  tabIndex="0" aria-label="Filter bulbs by school" @click="adminOrganizationSearch(scope.row.school_id, scope.row.school_name)">{{scope.row.school_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="teacher_name"
              label="Instructor"
              width= "200">
              <template slot-scope="scope" :data-bulb-id="scope.row.id" :data-thumbnail="scope.row.thumbnail">
                <span class ="selectable"  tabIndex="0" aria-label="Filter bulbs by teacher" @click="adminCreatorSearch(scope.row.teacher_id, scope.row.teacher_name)">{{scope.row.teacher_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="created"
              label="Created"
              width= "150">
            </el-table-column>
            <el-table-column
              v-if="!isMediaLibraryPlaylists"
              sortable="custom"
              prop="view_count"
              label="Views"
              width= "100">
              <template slot-scope="scope">
                <span>{{scope.row.view_count.toLocaleString('en')}}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              width="100"
              prop=""
              label="Actions">
              <template slot-scope="scope">
                <ActionMenu
                  v-if="!isMediaLibraryPlaylists"
                  :menu="'admin'"
                  tabIndex="0"
                  aria-label="Actions"
                  :bulb="scope.row"
                  icon="more_vert"
                  :disabled="selectedDataAdmin.length > 0"
                  :handlePopoverShow="handlePopoverShow">
                </ActionMenu>
                <ActionMenu
                  v-else
                  :menu="'admin'"
                  tabIndex="0"
                  aria-label="Actions"
                  :playlist="scope.row"
                  :icon="'more_vert'"
                  :handlePopoverShow="handlePopoverShow">
                </ActionMenu>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="column">
                <span>
                  No Media
                </span>
              </div>
            </template>
          </el-table>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
require("jquery-ui/ui/widgets/draggable");
require("jquery-ui/ui/widgets/droppable");
const Color = require('color');
import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState
} from 'vuex';
import ActionMenu from '../ActionMenu';
import Popover from '../Popover';
import _ from 'lodash';
import {
  addSortAccessibiltyEvents,
  waitForElementToDisplay,
} from '@utilities';
import * as focusTrap from 'focus-trap';

export default {
  name: 'admin-table',
  components: {
    ActionMenu, 
    Popover,
  },
  data() {
    return {
      explanation_graded_single: {},
      explanation_grade_student: {},
      dialogData: {},
      discussionToggle: false,
      showAllIntegrations:{},
      updateIntegrations: true,
      showAllTags:{},
      updateTags: true,
      showAllInstructors:{},
      updateInstructors: true,
      popoverReset: true,
      maxHeight: '',
      adminString: 'admin',
      expandedTreeFolderNode:[],
      folderTreeProps: {
          label: 'name',
          children: 'childrens',
          isLeaf: 'leaf',
      },
      treeNode: [],
      bulbNodeId:'',
      bulbTeacherId:'',
      selectedTableRows: [],
    };
  },
  computed: {
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'instructorData',
      'dialogShow',
      'popoverToggles',
      'nodeApiPrefix',
      'school',
      'LTIdata',
      'LTIlaunch',
      'LMSdata',
      'passbackLinking',
      'playerApiPrefix',
      'designerApiPrefix',
      'nodeApiPrefix',
      'userAgent',
    ]),
    ...mapGetters('instructors', [
    'refreshData',
    'activeViewInstructor',
    'queryParamsInstructors',
  ]),
   ...mapGetters('admin', [
    'activeViewAdmin',
    'adminAjaxing',
    'queryParamsAdmin',
    'schools',
    'bulbs',
    'instructors',
    'selectedDataAdmin',
    'refreshDataAdmin',
    'adminFilterSearch',
    'removeTreeFolderNode',
    'addTreeFolderNode',
    'treeBulbRow',
    'treeSubNodeData',
    'expandedNode',
    'updateTreeFolderResponse'
  ]),
    ...mapState('admin', [
    'adminDataLoaded',
    'adminFilterContentType',
    'playlists',
    'treeNodeData',
    'treeResponseData',
    'selectedNode'
    ]),
    filtersOn: function(){
      return (
        Object.keys(this.adminFilterSearch.creator).length > 0  ||
        this.adminFilterSearch.organization.length > 0 ||
        this.adminFilterSearch.age.length > 0 ||
        this.adminFilterSearch.subject.length > 0 ||
        this.adminFilterSearch.keywords.length > 0 ||
        this.adminFilterSearch.name.length > 0 ||
        this.adminFilterSearch.instructor.length > 0 ||
        this.adminFilterSearch.course.length > 0 ||
        this.adminFilterSearch.adminOnly ||
        this.adminFilterSearch.youtube != ''
      )
    },
    isMediaLibraryPlaylists() {
      return _.get(this.playlists, 'data', []).length > 0;
    },
    modalOpen: function(){
      return this.dialogShow.dash;
    },
    isSafari() {
      return _.get(this, 'userAgent.browser.name', '').toLowerCase() === 'safari';
    },
  },
  methods:{
    ...mapActions([
      'passbackContent',
      'sendProquestData',
    ]),
    ...mapActions('admin', [
      'launchAdminPlaylist',  
    ]),
    ...mapMutations([
      'handleDialogOpen',
      'setDashModal',
    ]),
    treeFolderNodeClicked(nodeData, treeNode, treeElement) {
      if(nodeData.schoolId && nodeData.schoolId === this.school.master_district?.id) return;
      if(!treeNode.expanded) treeNode.expanded = true;
      const nodeId = treeNode.data.parentId && this.school.id !== nodeData.schoolId 
        ? treeNode.data.id : 'root';
      this.$store.commit('admin/resetQueryParams');
      this.$store.commit('admin/setAdminNodeIdFilter', { nodeId });
      const previousSelectedNode = {...this.selectedNode};
      this.$store.commit('admin/setSelectedNode', treeNode.data); // setting selected Node for showing on the header 
      if(this.selectedNode.id !== previousSelectedNode.id) {
        this.$store.dispatch('admin/getTableData');
      }
      // this.loadTreeFolderNode(treeNode);
    },
    async loadTreeFolderNode(node, resolve) {
      node.data.nodeId = node.id;
      let isChildAdmin = 0;
      if(!node.expanded) node.expanded = true; // this handles to don't collapse the subfolder after clicking on folder name 
      this.$store.commit('admin/setExpandedNode', node.data); 
      if(!this.selectedNode.id) this.$store.commit('admin/setSelectedNode', node.data); // setting selected Node for showing on the header 
      this.$store.commit('admin/resetQueryParams');// reseting a pagination on folder click
      if (node.level === 0) { // this executed for the Master Node // for master node the level will be zero 
        this.$store.dispatch('admin/getTreeFolder');
        const nodeId = node.data.parentId ? node.data.id : 'root';
        this.$store.commit('admin/setAdminNodeIdFilter', { nodeId })
        this.$store.dispatch('admin/getTableData');
        const treeNode = this.generateNode(this.treeResponseData.data);
        this.$store.commit('admin/setTreeTableData',treeNode);
        if(resolve) return resolve(treeNode);
      }
      if (node.level > 0) { // this exceuted for the subfolder click 
        if(this.school.master_district?.id == node.data.schoolId && !node.data.parentId){
          isChildAdmin = 1;
          const nodeId = node.data.parentId ? node.data.id : 'root';
          this.$store.commit('admin/setAdminNodeIdFilter', { nodeId });
          this.$store.dispatch('admin/getTableData');
        }
        await this.$store.dispatch('admin/getTreeSubFolders', isChildAdmin);
        if(resolve) return resolve(this.treeSubNodeData.data);
      }
    },
    handleRowSelection(val) {
      this.$store.commit('admin/setSelectedData', val);
      this.selectedTableRows = val;
    },
    setMaxHeight: function(){
      if(this.filtersOn){
        this.maxHeight =  ((window.innerHeight - 290) < 290) ? 290 : (window.innerHeight - 290);
      } else {
        this.maxHeight =  ((window.innerHeight - 215) < 300) ? 300 : (window.innerHeight - 215);
      }
    },

    //table navigation functions
    setNavData: function(obj) {
      //set array data
      let active_view = obj.activeView;
      let query_params = obj.queryParams;
      let breadcrumbs = obj.breadcrumbs;

      breadcrumbs.unshift({text:'Administration', payload:''});
      let payload = {}
      this.$store.commit('updateBreadCrumbs' , [breadcrumbs, payload]);

      //sets breadcrumbs, query params, active view, and url
      this.$store.commit('admin/resetQueryParams');

      this.$store.commit('admin/setQueryParams', query_params)
      this.$store.commit('admin/setActiveView', [active_view]);
      this.$store.dispatch('admin/updateUrl');
    },

    //admin table actions

    signInAsInstructor: function(teacher_id){
      this.$store.dispatch('admin/signInAsTeacher', teacher_id)
    },
    handleMediaNameClicked(media) {
      if (this.adminFilterContentType === "Bulbs") {
        window.open(`${this.playerApiPrefix}/player_v2/?type=share&bulb_id=${media.id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
      } else {
        this.launchAdminPlaylist({
          playlistId: media.id,
          preview: true,
        });
      }
    },
    adminOrganizationSearch: function(id, name){
      this.$store.commit('admin/resetQueryParams');
      this.$store.dispatch('admin/updateUrl');
      this.$store.commit('admin/setQueryParams', {school_id: id});
      this.$store.commit('admin/setSchoolFilter', {id: id, name:name});
      this.$nextTick(()=> {
        this.$store.dispatch('admin/getTableData');
      })
    },
    adminCreatorSearch: function(id, name){
      this.$store.commit('admin/resetQueryParams');
      this.$store.dispatch('admin/updateUrl');
      const obj =  { ...this.adminFilterSearch };
      obj.creator = { id, name };
      this.$store.commit('admin/setAdminFilters', obj);
    },
    adminKeywordSearch: function(tag) {
      this.$store.commit('admin/resetQueryParams');
      this.$store.dispatch('admin/updateUrl');
      const obj =  { ...this.adminFilterSearch };
      const tagType = _.get(tag, 'type', tag.tag.type);
      if (tagType === 'age') {
        obj.age.push(tag.tag.value);
      } else if (tagType === 'subject') {
        obj.subject.push(tag.tag.value);
      } else if (tagType === 'user-generated') {
        obj.keywords.push(tag.text);
      }
      // If you click on the tag, it's implicitly expected that you're looking for that exact tag.
      // So default to always searching for exact match.
      obj.tagExactMatch = true;
      this.$store.commit('admin/setAdminFilters', obj);
    },

    /**
     * This function is sloppy and honestly is upsetting to read.
     * It handles sorting the tables when clicked.  Since I added keyboard events
     * it needed to be more specific and not just flip flop between ASC/DESC
     * 
     * @param event {
     *   column - the column from the table *not used in function or provided if event triggered by keyboardEvent*
     *   prop - the name of the data table prop used in the column
     *   order - 'ascending' (if from click) 'asc'/'desc' (from keyboardEvent)
     * }
    */
    sortChange: function (event) {
      if (
        !this.adminAjaxing
        && this.selectedDataAdmin.length === 0
      ) {
        let queryParams;
        if (
          this.queryParamsAdmin.sort === ''
          && event?.column
        ) {
          //if sort is not set, set sort to column prop ascending
          queryParams = { sort: `${event.prop} ASC` };
        } else if (!event?.column) { // event triggered by keyboardEvent
          const order = event.order === 'ascending' ? 'ASC' : 'DESC';
          queryParams = { sort: `${event.prop} ${order}` };
        } else if (event.prop === null) {
          queryParams = { sort: '' };
        } else {
          //if sort is set, find name and order
          let name = this.queryParamsAdmin.sort.split(' ')[0];
          let order = this.queryParamsAdmin.sort.split(' ')[1];

          if (event.prop != name) {
            //if it is a new name, set sort to new column name ascending
            queryParams = { sort: `${event.prop} ASC` };
          } else if (
            event.prop === name
            && order === 'ASC'
          ) {
            //if it is the same column and asc, change to desc
            queryParams = { sort: `${event.prop} DESC` };
          } else if (
            event.prop === name
            && order === 'DESC'
          ) {
            //if it is the same column and desc, change to asc
            queryParams = { sort: `${event.prop} ASC` };
          }
        }
        //sets query params, calls data, and updates url
        this.$store.commit('admin/setQueryParams', queryParams);
        this.$store.dispatch('admin/getTableData');
        this.$store.dispatch('admin/updateUrl');
      }
    },


    //function to handle selection
    selectionChange:function(event){
      //stores selected data to state
      this.$store.commit('admin/setSelectedData', event);
    },
    showIntegrations:function(row){
      if(row.integrations.length > 3){
        this.showAllIntegrations[row.id] ? this.showAllIntegrations[row.id] = false : this.showAllIntegrations[row.id] = true;
        this.updateIntegrations = false;
        setTimeout(() => this.updateIntegrations = true, .05);
      }
    },
    showTags: function (row) {
      if (
        _.get(row, 'tags', []).length > 3
        || _.get(row, 'playlistTags', []).length > 3
      ) {
        this.showAllTags[row.id] ? this.showAllTags[row.id] = false : this.showAllTags[row.id] = true;
        this.updateTags = false;
        setTimeout(() => this.updateTags = true, .05);
      }
    },
    showInstructors:function(row){
      if(row.instructors.length > 3){
        this.showAllInstructors[row.id] ? this.showAllInstructors[row.id] = false : this.showAllInstructors[row.id] = true;
        this.updateInstructors = false;
        setTimeout(() => this.updateInstructors = true, .05);
      }
    },


    // actions to create css/style
    sortClasses: function(event) {
      if (
        !this.adminAjaxing
        && this.selectedDataAdmin.length === 0
      ) {
        let sortArray = this.queryParamsAdmin.sort.split(" ");
        // changes header class based on sort
        let sortClass;
        if (_.snakeCase(event.column.property) === sortArray[0]) {
          // returns class based on desc or asc sort to change arrow color
          (sortArray[1] === 'DESC') ? sortClass= 'descSelected' : sortClass= 'ascSelected';
          return sortClass;
        } else {
          // if no sort, return noSelected class
          return 'noSelected';
        }
      }
    },
    schoolStyle:function(obj){
      let color = (obj.color) ? obj.color : '#858585';
      if(obj.logo){
        return {
          backgroundColor: color,
          backgroundImage: `url("${obj.logo}")`
        }
      } else {
        return {
          backgroundColor: color,
          backgroundImage: `url("https://res.cloudinary.com/dkyxchav6/image/upload/v1556650043/baseline_school_white_18dp.png")`
        }
      }
    },
    tagStyle: function(data){
      let color = _.get(data, 'tag.hex', data.color);
      color = color ? color : '#FAFAFA';
      let darkColor = Color(color).darken(0.60).hex();
      return {
        'backgroundColor': color,
        'color': darkColor,
        'border': `solid 1px ${darkColor}`,
        'borderRadius': '20px',
        'cursor': 'pointer'
      }
    },
    handleProquestBulbDeletionData(bulbId) {
      if (this.$route.name !== 'admin') return;
      let proquestBulbIds;
      if (this.selectedDataAdmin?.length) {
        proquestBulbIds = this.selectedDataAdmin
          .filter((bulb) => bulb.isProquestBulb)
          .map((bulb) => bulb.id);
      } else if (bulbId) {
        const match = this.bulbs.data.find((bulb) => (
          bulb.id === bulbId
          && bulb.isProquestBulb
        ));
        if (match) proquestBulbIds = [bulbId];
      }
      if (!proquestBulbIds.length) return;
      for (const bulbId of proquestBulbIds)  {
        this.sendProquestData({
          id: bulbId,
          type: 'bulb',
          event: 'delete',
          skipCallback: true,
        });
      }
    },
    //listeners
    addListeners:function(){
      window.addEventListener('resize', this.adjustMaxHeight);
      EventBus.$on('sendProquestBulbDeletionData', this.handleProquestBulbDeletionData);
    },
    removeListeners:function(){
      window.removeEventListener('resize', this.adjustMaxHeight);
      EventBus.$off('sendProquestBulbDeletionData', this.handleProquestBulbDeletionData);
    },
    adjustMaxHeight: function(event){
      this.maxHeight =  window.innerHeight - 215;
    },
    //Here we are adding the childers to his parents as first time the all master and master subnodes are getting loaded 
    generateNode: function(data){
      let parent = [];
      if(data){
        let root = [...data.filter(ele => {
          if(ele.parentId === null) return true;
          return false;
        })];
        this.expandedTreeFolderNode = root.map((node) => node.id);
        let node ;
        for (node of root) {
          node.childrens = [];
          node.childrens = [...data.filter(ele => ele.parentId === node.id)];
          // expand child school 
          if(!root.parentId) {
            for (const child of node.childrens) {
              if(child.schoolId === this.school.id) {
                this.expandedTreeFolderNode.push(child.id);
              }
            }
          }
          parent.push(node);
        }
      }
      return parent;
    },
    removeFolder: function (data){
      this.$store.dispatch('admin/removeTreeFolder',data.id);
    },
   // After drop the bulb on tree calls this method 
    handleTreeFolderDrop: async function(draggingNode, dropNode, dropType, ev) {
      dropNode.expanded = true; // this expands the treenode on wich the folder got dropped
      const updatingNode = {...draggingNode.data};
      updatingNode.parentId = (dropType === 'inner') ? dropNode.data.id : dropNode.data.parentId ;
      await this.$store.dispatch('admin/dragUpdateFolder', updatingNode); // updates the tree_node ;
      if(this.updateTreeFolderResponse.msg === 'success' && this.updateTreeFolderResponse.data.length > 0){
        draggingNode.data.parentId = updatingNode.parentId;
      }
      dropNode.childNodes = this.sortChildNodes(dropNode.childNodes);
    },
    sortChildNodes: function(nodes){
      nodes = nodes.sort(function(a, b){
        const nameA = a.data.name.toLowerCase(), nameB = b.data.name.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1 
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
      });
      return [...nodes.filter((node) => (node.data.schoolId)), ...nodes.filter((node) => (!node.data.schoolId))];
    },
    allowTreeFolderDrag: function(node) {
      return !this.adminAjaxing;
    },
    //Handling to not allow drop outside of the master folder 
    allowTreeFolderDrop: function (draggingNode, dropNode, type) {
      if(this.adminAjaxing ) return false;
      if(type !== "inner") return false;
      if(this.school.master_district?.id == dropNode.data.schoolId ) return false;
      if((dropNode.data.parentId === null && type !== "inner") || (dropNode.id === draggingNode.id) ) {
        return false;
      }
      return true;
    },
    // this function trucate the foldre names
    truncateFolderName: (str, n) => ((str.length > n) ? str.substr(0, n - 1) + '...' : str),
    async handlePopoverShow(e) { // When a popover is opened await nextTick then find the popover element that is active and set focus to it.
      await this.$nextTick();
      const popovers = document.getElementsByClassName('el-popper');
      const activePopover = _.find(popovers, (popover) => {
        if (_.get(popover, 'style.display') !== 'none') return popover;
      });
      await this.$nextTick();
      if (activePopover) {
        this.trap = focusTrap.createFocusTrap(activePopover, {
          clickOutsideDeactivates: true,
          fallbackFocus: activePopover,
        });
        this.trap.activate();
      }
    },
  },
  watch: {
    async adminDataLoaded(newValue) {
      if (newValue) {
        const caretWrapper = await waitForElementToDisplay('.caret-wrapper')
        if (caretWrapper) addSortAccessibiltyEvents(this.sortChange, this.activeView, this.activeViewAdmin);
      }
    },
    refreshData: {
      handler: function(val){
        if(val){
          this.$store.commit('admin/setSelectedData', []);
          this.selectedTableRows = []; // separate from selectedDataAdmin, used for drag and drop to folders
          this.$store.commit('instructors/refreshComplete');
          this.$store.dispatch('admin/getTableData');
        }
      }
    },
    refreshDataAdmin: {
      handler: function(val, oldVal){
        if(val){
          this.$store.commit('admin/refreshComplete');
          this.$store.dispatch('admin/getTableData');
        }
      }
    },
    filtersOn: {
      handler: function(val){
        if(val){
          this.maxHeight =  ((window.innerHeight - 275) < 300) ? 300 : (window.innerHeight - 275);
        } else {
          this.maxHeight =  ((window.innerHeight - 215) < 300) ? 300 : (window.innerHeight - 215);
        }
      }
    },
    treeResponseData: {
      handler: function(val, oldVal) {
        this.treeNode = this.generateNode(val.data);
      }
    },
    removeTreeFolderNode: {
      handler: function(val, oldVal){
        const removingNode = this.$refs.tree.getNode(val);
        this.$refs.tree.remove(removingNode);
      }
    },
    addTreeFolderNode: {
      handler: function(val, oldVal){
        let parentNode = this.$refs.tree.getNode(this.selectedNode);
        this.$refs.tree.append(val,parentNode);
        parentNode.childNodes = this.sortChildNodes(parentNode.childNodes);
      }
    },
  },
  mounted() {
    this.setMaxHeight();
    this.addListeners();
  },
  updated() {
    if(this.activeViewAdmin === 'Treeview') {
      this.$nextTick(() => {
        const _this = this;
        const tbody = document.querySelector('.el-table__body-wrapper tbody');
        $(tbody).find('.el-table__row').each((i, el) => {
          $(el).draggable({
            cursor: 'none',
            cursorAt: {top:5, left: 5},
            appendTo: 'body',
            containment: $('parent'),
            helper: 'clone',
            zIndex: 199,
            helper: function( event ) {
              const counter = _this.selectedTableRows.length > 1 ? `<span class="circle" >${_this.selectedTableRows.length}</span>` : '';
              const ele = $(this).find('.thumbnail-wrapper')[0];
              let thumbnail = _this.selectedTableRows.length > 0
                ? _this.selectedTableRows[0].thumbnail
                : ele
                  ? $(ele).css('background-image').replace(/^url\(['"]?/,'').replace(/['"]?\)$/,'')
                  : null;
              if( thumbnail == 'none' ) {
                if( $(el).find('span')[2]
                  && $(el).find('span')[2].attributes
                  && $(el).find('span')[2].attributes['data-thumbnail']
                  && $(el).find('span')[2].attributes['data-thumbnail'].value ) thumbnail = $(el).find('span')[2].attributes['data-thumbnail'].value;
              }
              if(!thumbnail) thumbnail = 'https://cdn.playposit.com/image-uploads/image-11-04-2019-15-31-41--placeholder.png';
              return $(`<div class='ui-widget-header' style="width: 64px; height: 36px; background-size: cover;background-position: center;background-color: #0390fc;background-image: url('`+thumbnail+`');">
                <svg style="position:absolute;width:24px;height:24px;top:5px;left:20px;color:white" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M3 9.25V15.75C3 20.31 6.69 24 11.25 24S19.5 20.31 19.5 15.75V5.75C19.5 5.06 18.94 4.5 18.25 4.5S17 5.06 17 5.75V12H16V2.75C16 2.06 15.44 1.5 14.75 1.5S13.5 2.06 13.5 2.75V11H12.5V1.25C12.5 .56 11.94 0 11.25 0S10 .56 10 1.25V11H9V3.25C9 2.56 8.44 2 7.75 2C7.06 2 6.5 2.56 6.5 3.25V14.03C8.47 14.28 10 15.96 10 18H9C9 16.35 7.65 15 6 15H5.5V9.25C5.5 8.56 4.94 8 4.25 8S3 8.56 3 9.25Z" />
                </svg>
              ${counter}</div>`);
            },
          });
        });
      });
    }
  },
  directives: {
    droppable: {
      self : this,
      inserted:  (el, binding, vnode) => {
        if($(el) && $(el).parent() && $(el).parent().parent() && !$(el).parent().parent().hasClass('ui-droppable')) {
          $(el).parent().parent().droppable({
            hoverClass: "highlight",
            drop(e, ui) {
              let bulbIds = vnode.context.selectedTableRows.length > 0 
                ? _.map(vnode.context.selectedTableRows, 'id') 
                : [$($($($(ui.draggable[0]).find('.cell')[1])[0])[0]).find('span').attr('data-bulb-id')];
                
              const parentNodeId  = vnode.context.selectedTableRows.length > 0 ? vnode.context.selectedTableRows[0] : vnode.context.bulbs.data.filter((bulb) => bulb.id ==  bulbIds[0])[0];
              const parentId = $(e.target).find('span[data-parent-id]').first().attr('data-parent-id');
              const nodeId = parentId ? $(e.target).find('span[data-tree-id]').first().attr('data-tree-id') : null;
              if((parentNodeId.nodeId != nodeId) && (nodeId || nodeId === null) && bulbIds.length > 0 ) {
                const obj = {
                  nodeId,
                  bulbIds,
                };
                vnode.context.$store.dispatch('admin/updateTreeBulbNode', obj);
                vnode.context.selectedTableRows = [];
                vnode.context.$store.commit('admin/setSelectedData', []);
              }
            },
          });
        }
      }
    },
  },
  beforeDestroy(){
    this.removeListeners();
  },
};
</script>

<style scoped>
  #instructor-table-dynamic {
    width: 100%;
    padding: 0px 36px;
  }
  
  /*.el-tree-node > .el-tree-node__children { overflow: visible; } */
  .el-badge.item { margin-top: 10px; }
  .el-badge.item .v-avatar {
    margin-left: 8px;
  }
  
</style>

<style type="text/css">
  .el-tree-node__content:hover, .el-tree-node__content:hover .folderName {
    background-color: #d4d4d4 !important;
  }
  .el-tree-node__content:focus, .el-tree-node__content:focus .folderName {
    background-color: #ffffff !important;
  }
  .el-tree-node__content:focus {
    outline: 1px solid blue;
  }
  .el-tree-node__content {
    box-sizing: content-box;
    min-width: 150px;
  }
  .el-tree > .el-tree-node{
    display: inline-block !important;
  }
  .el-tree {
    overflow: auto;
    margin-right: 3rem;
    width: auto;
    min-width: 100%;
    max-height: 75vh;
  }
  .highlight, .highlight span.folderName {
    background-color: #d1d1d1;
  }
  .highlight span.folderName {
    font-weight:800 !important;
  }
  .progressBar{
    margin-top: 125px;
  }
  /* Clear floats after the columns */
  .row:after {
    content: "";
    display: table;
    clear: both;
  }
  .folderName{
    /*padding: 3px 5px 2px 0;*/
    /*position: absolute;*/
    /*background-color: red;*/
    vertical-align: text-bottom;
  }
  /*.el-tree_custom-node {position:relative}*/
  .dragElement {
    background-color: #e6e3e3 !important;
  }
  
  div.el-tree-node.is-drop-inner {
    background-color: #e8e8e8 !important;
  }
  
  div.el-tree-node.is-drop-inner span.folderName {
    font-weight:800 !important;
  }
  
  .circle{
    -webkit-border-radius:25px;
    -moz-border-radius:25px;
    border-radius:25px;
    background-color: #03adfc;
    border:1px solid #ccc;
    width:40%;
    height:60%;
    position: absolute;
    text-align: center;
    color: #ffffff;
    top:60%;
    left:85%;
    /*padding: 5px;*/
    font-weight:bold; 
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>


